import GhostContentAPI from '@tryghost/content-api';

const GHOST_API = new GhostContentAPI({
  url: `https://starlies.minervaarticles.com`,
  key: `609bd136b38a1d9fd7bb9058d7`,
  version: `v3`,
});

const FACEBOOK_LINK = `https://www.facebook.com/signsbystarguide`;
const INSTAGRAM_LINK = `https://www.instagram.com/signsbystarguide/`;

export { GHOST_API, FACEBOOK_LINK, INSTAGRAM_LINK };
